import React from "react";
import ReactSelect from "react-select";

export type SelectProps = {
  items?: any[];
  selectedItem?: any;
  onChange?: (id: string) => void;
  placeholder?: string;
  classNamePrefix?: string;
};

export const Select = ({
  items = [],
  selectedItem,
  onChange,
  placeholder,
  classNamePrefix = "react-select",
}: SelectProps) => {
  return (
    <div className="gpc__select">
      <ReactSelect
        classNamePrefix={classNamePrefix}
        placeholder={placeholder}
        value={selectedItem && { value: selectedItem, label: selectedItem }}
        onChange={(selected) => selected && onChange?.(selected.value)}
        options={items.map((item) => ({ value: item, label: item }))}
      />
    </div>
  );
};

export default Select;
